import React from "react";

const Bar = ({ className = "" }) => (
  <div className={`animate-pulse rounded bg-cloud-mist ${className}`} />
);

/** Placeholder with the same geometry as the testimonial quote panel. */
const TestimonialSkeleton = () => (
  <div
    aria-busy="true"
    className="relative flex max-w-4xl flex-col rounded-brand border border-cloud-mist bg-mist-panel p-8 shadow-brand-sm sm:min-h-[300px] sm:p-10"
  >
    <p className="sr-only">Loading testimonials…</p>
    <div
      aria-hidden="true"
      className="pointer-events-none absolute right-6 top-6 text-sunshine"
    >
      <svg fill="none" height="28" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="28">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </div>

    <div
      aria-hidden="true"
      className="flex min-h-[7.5rem] flex-1 flex-col gap-3 pb-6 pr-8 sm:min-h-[8.5rem]"
    >
      <Bar className="h-6 w-[92%]" />
      <Bar className="h-6 w-full" />
      <Bar className="h-6 w-[96%]" />
      <Bar className="h-6 w-3/5" />
    </div>

    <div
      aria-hidden="true"
      className="mt-auto flex items-center justify-between gap-4 border-t border-cloud-mist pt-4"
    >
      <div className="flex min-w-0 flex-col gap-2">
        <Bar className="h-4 w-36" />
        <Bar className="h-3 w-52" />
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Bar className="h-10 w-10 rounded-brand" />
        <Bar className="h-10 w-10 rounded-brand" />
      </div>
    </div>
  </div>
);

export default TestimonialSkeleton;
